import { render } from "./RecoveryBornModal.vue?vue&type=template&id=afe8c98c&scoped=true"
import script from "./RecoveryBornModal.vue?vue&type=script&lang=js"
export * from "./RecoveryBornModal.vue?vue&type=script&lang=js"

import "./RecoveryBornModal.vue?vue&type=style&index=0&id=afe8c98c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe8c98c"]])

export default __exports__